import { render } from "./TiendaProductoAddSocio.vue?vue&type=template&id=874fec12"
import script from "./TiendaProductoAddSocio.vue?vue&type=script&lang=ts"
export * from "./TiendaProductoAddSocio.vue?vue&type=script&lang=ts"
script.render = render

export default script